import { RSAA } from 'redux-api-middleware';
import fetch from 'isomorphic-fetch';
import api from '../../api';

// ------------------------------------
// Constants
// ------------------------------------
const LOAD_REQUEST = 'farmakom/posts/LOAD_REQUEST';
const LOAD_SUCCESS = 'farmakom/posts/LOAD_SUCCESS';
const LOAD_FAILURE = 'farmakom/posts/LOAD_FAILURE';

const LOAD_LATEST_REQUEST = 'farmakom/posts/LOAD_LATEST_REQUEST';
const LOAD_LATEST_SUCCESS = 'farmakom/posts/LOAD_LATEST_SUCCESS';
const LOAD_LATEST_FAILURE = 'farmakom/posts/LOAD_LATEST_FAILURE';

// ------------------------------------
// Actions
// ------------------------------------

// API CALL
export function loadPosts(params, query) {
  return {
    [RSAA]: {
      ...api.getPosts(query.page, 9),
      types: [LOAD_REQUEST, LOAD_SUCCESS, LOAD_FAILURE]
    }
  }
}

// API CALL
export function loadSidebarPosts(params, query) {
  return {
    [RSAA]: {
      ...api.getPosts(1, 4),
      types: [LOAD_LATEST_REQUEST, LOAD_LATEST_SUCCESS, LOAD_LATEST_FAILURE]
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  loading: false,
  error: '',
  data: {
    posts: [],
    latest: []
  },
  pagination: {
    page: 1,
    totalPages: 1
  }
};

export default function postsReducer (state = initialState, action) {
  switch(action.type) {
    case LOAD_REQUEST:
      return {
        ...state,
        loading: true
      }
		case LOAD_SUCCESS:
			return {
        ...state,
        loading: false,
        data: {
          ...state.data, 
          posts: action.payload.items
        },
        pagination: action.payload.pagination,
        error: null
      }
    case LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      }
    case LOAD_LATEST_REQUEST:
      return {
        ...state,
        loading: true
      }
		case LOAD_LATEST_SUCCESS:
			return {
        ...state,
        loading: false,
        data: {
          ...state.data, 
          latest: action.payload.items
        },
        pagination: action.payload.pagination,
        error: null
      }
    case LOAD_LATEST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message
      }
    default:
      return state;
  }
}
